import { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import Page from '../pages/Page'
import FetchContext from '../../context/fetch/FetchContext'
import RepliesTable from './RepliesTable'
import { repliesQueryKey } from './repliesQueryKey'
import { resolveReplyRows } from './resolveReplyRows'

export default function RepliesPage() {
    const navigate = useNavigate()
    const fetcher = useContext(FetchContext)

    const {
        data: replies,
        isFetching,
        isLoading,
    } = useQuery({
        queryKey: repliesQueryKey(),
        queryFn: () => fetcher.fetchReplies(),
    })

    return (
        <Page
            className="replies"
            title="תגובות"
            busy={isFetching || isLoading}
        >
            <RepliesTable
                rows={resolveReplyRows(replies)}
                onOpen={(row) => navigate(`/replies/${row.id}`)}
            />
        </Page>
    )
}
